import { useState } from "react";

interface AgentNameCellProps {
  name: string | null;
  logoUrl?: string | null;
}

export const AgentNameCell = ({ name, logoUrl }: AgentNameCellProps) => {
  const [failedLogoUrl, setFailedLogoUrl] = useState<string | null>(null);
  const label = name || "Unknown";
  const showLogo = Boolean(logoUrl) && logoUrl !== failedLogoUrl;

  return (
    <span className="inline-flex items-center gap-2 min-w-0">
      {showLogo ? (
        <img
          src={logoUrl!}
          alt=""
          loading="lazy"
          onError={() => setFailedLogoUrl(logoUrl!)}
          className="h-6 w-6 rounded-full flex-shrink-0 object-contain bg-white border border-genie-border"
        />
      ) : (
        <span className="h-6 w-6 rounded-full flex-shrink-0 flex items-center justify-center bg-genie-background-muted border border-genie-border text-[10px] font-semibold text-genie-text-secondary">
          {label.charAt(0).toUpperCase()}
        </span>
      )}
      <span className="break-words">{label}</span>
    </span>
  );
};
